var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid d-flex flex-wrap justify-content-between"},[_vm._m(0),_c('div',{staticClass:"copyright d-flex flex-wrap font-montserrat"},[_vm._v("\n      © "+_vm._s(_vm.currentYear)+" | Матрица компетенций\n    ")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('nav',[_c('ul',[_c('li')])])
}]

export { render, staticRenderFns }